import { apiSlice } from "./apiSlice";

export const mapitShipInvoiceApi = apiSlice
    .enhanceEndpoints({
        addTagTypes: ['MAPIT-SHIP-INVOICE', 'WALLET', 'TAP-PAYMENT-CARDS'],
    })
    .injectEndpoints({
        endpoints: builder => ({
            //======== Merchant ========
            getUpcomingInvoice: builder.query({
                query: (params) => ({
                    url: `/cod-invoice/merchant/upcoming`,
                    method: 'GET',
                    params
                }),
                providesTags: ['MAPIT-SHIP-INVOICE'],
                transformResponse: (response, meta, arg) => response?.body,
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            getXlsxUpcomingInvoice: builder.query({
                query: (params) => ({
                    url: `/cod-invoice/merchant/upcoming/xls`,
                    method: 'GET',
                    params
                }),
                providesTags: ['MAPIT-SHIP-INVOICE'],
                transformResponse: (response, meta, arg) => response?.body,
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            getCurrentInvoice: builder.query({
                query: (params) => ({
                    url: `/cod-invoice/merchant/current`,
                    method: 'GET',
                    params
                }),
                providesTags: ['MAPIT-SHIP-INVOICE'],
                transformResponse: (response, meta, arg) => response?.body,
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            getXlsxCurrentInvoice: builder.query({
                query: (params) => ({
                    url: `/cod-invoice/merchant/current/xls`,
                    method: 'GET',
                    params
                }),
                providesTags: ['MAPIT-SHIP-INVOICE'],
                transformResponse: (response, meta, arg) => response?.body,
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            getSettledInvoices: builder.query({
                query: (params) => ({
                    url: `/cod-invoice/merchant/settled`,
                    method: 'GET',
                    params
                }),
                providesTags: ['MAPIT-SHIP-INVOICE'],
                transformResponse: (response, meta, arg) => response?.body,
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            getXlsxSettledInvoice: builder.query({
                query: ({ invoiceId, email }) => ({
                    url: `/cod-invoice/${invoiceId}/settled/xls`,
                    method: 'GET',
                    params: { email }
                }),
                providesTags: ['MAPIT-SHIP-INVOICE'],
                transformResponse: (response, meta, arg) => response?.body,
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            //======== Admin ========
            getInvoices: builder.query({
                query: (params) => ({
                    url: `/cod-invoice`,
                    method: 'GET',
                    params
                }),
                providesTags: ['MAPIT-SHIP-INVOICE'],
                transformResponse: (response, meta, arg) => response?.body,
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            getXlsxUpcomingInvoiceByMerchant: builder.query({
                query: ({ merchantId, email }) => ({
                    url: `/cod-invoice/merchant/${merchantId}/upcoming/xls`,
                    method: 'GET',
                    params: { email }
                }),
                providesTags: ['MAPIT-SHIP-INVOICE'],
                transformResponse: (response, meta, arg) => response?.body,
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            getXlsxCurrentInvoiceByMerchant: builder.query({
                query: ({ merchantId, email }) => ({
                    url: `/cod-invoice/merchant/${merchantId}/current/xls`,
                    method: 'GET',
                    params: { email }
                }),
                providesTags: ['MAPIT-SHIP-INVOICE'],
                transformResponse: (response, meta, arg) => response?.body,
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            settleInvoice: builder.mutation({
                query: ({ merchantId }) => ({
                    url: `/cod-invoice/${merchantId}/settle`,
                    method: 'PUT'
                }),
                invalidatesTags: ['MAPIT-SHIP-INVOICE'],
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            getXlsxCurrentInvoicesByAdmin: builder.query({
                query: (params) => ({
                    url: `/cod-invoice/current/xls`,
                    method: 'GET',
                    params
                }),
                providesTags: ['MAPIT-SHIP-INVOICE'],
                transformResponse: (response, meta, arg) => response?.body,
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            // getCODInvoicesStatistics: builder.query({
            //     query: (params) => ({
            //         url: `/cod-invoice/admin/stats`,
            //         method: 'GET',
            //         params
            //     }),
            //     providesTags: ['MAPIT-SHIP-INVOICE'],
            //     transformResponse: (response, meta, arg) => response?.body,
            //     transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            // }),
            getCompletedOrdersByInvoiceId: builder.query({
                query: ({ invoiceId, ...params }) => ({
                    url: `/cod-invoice/completed-orders/${invoiceId}`,
                    method: 'GET',
                    params
                }),
                providesTags: ['MAPIT-SHIP-INVOICE'],
                transformResponse: (response, meta, arg) => response?.body,
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            getReturnedOrdersByInvoiceId: builder.query({
                query: ({ invoiceId, ...parasm }) => ({
                    url: `/cod-invoice/returned-orders/${invoiceId}`,
                    method: 'GET',
                    parasm
                }),
                providesTags: ['MAPIT-SHIP-INVOICE'],
                transformResponse: (response, meta, arg) => response?.body,
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            chargeFromCodWallet: builder.mutation({
                query: (payload) => ({
                    url: `/wallet/cod/charge`,
                    method: 'POST',
                    body: { ...payload }
                }),
                invalidatesTags: ['MAPIT-SHIP-INVOICE', 'WALLET'],
                transformResponse: (response, meta, arg) => response?.body,
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            //======== Withdrawal & Transactions ========
            requestWithdrawal: builder.mutation({
                query: (payload) => ({
                    url: `/cod-invoice/request-withdrawal`,
                    method: 'POST',
                    body: payload
                }),
                invalidatesTags: ['MAPIT-SHIP-INVOICE'],
                transformResponse: (response, meta, arg) => response?.body,
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            updateWithdrawalRequestStatus: builder.mutation({
                query: (payload) => ({
                    url: `/cod-invoice/request-withdrawal`,
                    method: 'PUT',
                    body: payload
                }),
                invalidatesTags: ['MAPIT-SHIP-INVOICE'],
                transformResponse: (response, meta, arg) => response?.body,
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            getCodTransactionsByAdmin: builder.query({
                query: (params) => ({
                    url: `/cod-invoice/transactions/admin`,
                    method: 'GET',
                    params
                }),
                providesTags: ['MAPIT-SHIP-INVOICE'],
                transformResponse: (response, meta, arg) => response?.body,
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            getCodTransactions: builder.query({
                query: (params) => ({
                    url: `/cod-invoice/transactions`,
                    method: 'GET',
                    params
                }),
                providesTags: ['MAPIT-SHIP-INVOICE'],
                transformResponse: (response, meta, arg) => response?.body,
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            getCodTransactionsById: builder.query({
                query: ({ transactionId, params }) => ({
                    url: `/cod-invoice/transactions/${transactionId}`,
                    method: 'GET',
                    params
                }),
                providesTags: ['MAPIT-SHIP-INVOICE'],
                transformResponse: (response, meta, arg) => response?.body,
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            getCodTransactionsStats: builder.query({
                query: (params) => ({
                    url: `/cod-invoice/stats`,
                    method: 'GET',
                    params
                }),
                providesTags: ['MAPIT-SHIP-INVOICE'],
                transformResponse: (response, meta, arg) => response?.body,
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            getCodTransactionsStatsByAdmin: builder.query({
                query: (params) => ({
                    url: `/cod-invoice/stats/admin`,
                    method: 'GET',
                    params
                }),
                providesTags: ['MAPIT-SHIP-INVOICE'],
                transformResponse: (response, meta, arg) => response?.body,
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            getCodTransactionsXls: builder.query({
                query: (params) => ({
                    url: `/cod-invoice/transactions/xls`,
                    method: 'GET',
                    params
                }),
                transformResponse: (response, meta, arg) => response?.body,
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            getCodTransactionsOrdersXls: builder.query({
                query: ({ codTransactionId, params }) => ({
                    url: `/cod-invoice/transactions/${codTransactionId}/xls`,
                    method: 'GET',
                    params
                }),
                transformResponse: (response, meta, arg) => response?.body,
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            getCodTransactionsXlsByAdmin: builder.query({
                query: (params) => ({
                    url: `/cod-invoice/transactions/xls/admin`,
                    method: 'GET',
                    params
                }),
                transformResponse: (response, meta, arg) => response?.body,
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            requestWithdrawalByAdmin: builder.mutation({
                query: (payload) => ({
                    url: `/cod-invoice/request-withdrawal/admin`,
                    method: 'POST',
                    body: payload
                }),
                invalidatesTags: ['MAPIT-SHIP-INVOICE'],
                transformResponse: (response, meta, arg) => response?.body,
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            convertToCurrentInvoice: builder.mutation({
                query: (payload) => ({
                    url: `/cod-invoice/admin`,
                    method: 'PUT',
                    body: payload
                }),
                invalidatesTags: ['MAPIT-SHIP-INVOICE'],
                transformResponse: (response, meta, arg) => response?.body,
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            getWithdrawalsTransactionsCount: builder.query({
                query: (params) => ({
                    url: `/cod-invoice/with-drawal-transactions-count`,
                    method: 'GET',
                    params
                }),
                transformResponse: (response, meta, arg) => response?.body,
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            createCharge: builder.mutation({
                query: (payload) => ({
                    url: `/payment/tap/create-charge`,
                    method: 'POST',
                    body: payload
                }),
                transformResponse: (response, meta, arg) => response?.body,
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            getSavedCards: builder.query({
                query: (params) => ({
                    url: `/payment/tap/saved-cards`,
                    method: 'GET',
                    params
                }),
                providesTags: ['TAP-PAYMENT-CARDS'],
                transformResponse: (response, meta, arg) => response?.body,
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            deleteSavedCard: builder.mutation({
                query: (cardId) => ({
                    url: `/payment/tap/saved-cards/${cardId}`,
                    method: 'DELETE',
                }),
                invalidatesTags: ['TAP-PAYMENT-CARDS'],
                transformResponse: (response, meta, arg) => response?.body,
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            getCouponsCard: builder.query({
                query: (params) => ({
                    url: `/setting`,
                    method: 'GET',
                    params
                }),
                transformResponse: (response, meta, arg) => response?.body,
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            applyCouponCode: builder.mutation({
                query: (payload) => ({
                    url: `/coupons/apply-coupon`,
                    method: 'POST',
                    body: payload
                }),
                transformResponse: (response, meta, arg) => response?.body,
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
        })
    })

export const {
    useGetUpcomingInvoiceQuery,
    useLazyGetXlsxUpcomingInvoiceQuery,
    useGetCurrentInvoiceQuery,
    useLazyGetXlsxCurrentInvoiceQuery,
    useGetSettledInvoicesQuery,
    useLazyGetXlsxSettledInvoiceQuery,
    useGetInvoicesQuery,
    useLazyGetInvoicesQuery,
    useLazyGetXlsxUpcomingInvoiceByMerchantQuery,
    useLazyGetXlsxCurrentInvoiceByMerchantQuery,
    useSettleInvoiceMutation,
    useLazyGetXlsxCurrentInvoicesByAdminQuery,
    // useGetCODInvoicesStatisticsQuery,
    useGetCompletedOrdersByInvoiceIdQuery,
    useGetReturnedOrdersByInvoiceIdQuery,
    useChargeFromCodWalletMutation,
    useRequestWithdrawalMutation,
    useUpdateWithdrawalRequestStatusMutation,
    useGetCodTransactionsByAdminQuery,
    useLazyGetCodTransactionsByAdminQuery,
    useGetCodTransactionsQuery,
    useLazyGetCodTransactionsQuery,
    useLazyGetCodTransactionsXlsQuery,
    useLazyGetCodTransactionsXlsByAdminQuery,
    useGetCodTransactionsStatsQuery,
    useGetCodTransactionsByIdQuery,
    useLazyGetCodTransactionsOrdersXlsQuery,
    useRequestWithdrawalByAdminMutation,
    useGetCodTransactionsStatsByAdminQuery,
    useConvertToCurrentInvoiceMutation,
    useGetWithdrawalsTransactionsCountQuery,
    useCreateChargeMutation,
    useGetSavedCardsQuery,
    useDeleteSavedCardMutation,
    useGetCouponsCardQuery,
    useApplyCouponCodeMutation
} = mapitShipInvoiceApi
